// Group Store - Zustand State Management
import { create } from 'zustand';
import { IGroup, IGroupDetail } from '../interfaces/IGroup';

interface GroupState {
  groups: IGroup[];
  selectedGroup: IGroupDetail | null;
  isLoading: boolean;
  error: string | null;
  setGroups: (groups: IGroup[]) => void;
  setSelectedGroup: (group: IGroupDetail | null) => void;
  addGroup: (group: IGroup) => void;
  updateGroup: (id: string, group: IGroup) => void;
  removeGroup: (id: string) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useGroupStore = create<GroupState>((set) => ({
  groups: [],
  selectedGroup: null,
  isLoading: false,
  error: null,

  setGroups: (groups: IGroup[]) => set({ groups }),
  setSelectedGroup: (group: IGroupDetail | null) => set({ selectedGroup: group }),
  addGroup: (group: IGroup) =>
    set((state) => ({
      groups: [group, ...state.groups],
    })),
  updateGroup: (id: string, group: IGroup) =>
    set((state) => ({
      groups: state.groups.map((g) => (g.id === id ? group : g)),
    })),
  removeGroup: (id: string) =>
    set((state) => ({
      groups: state.groups.filter((g) => g.id !== id),
    })),
  setLoading: (loading: boolean) => set({ isLoading: loading }),
  setError: (error: string | null) => set({ error }),
}));
